<div *ngIf="file" class="file-notification">
  <mat-icon class="attach-icon">attach_file</mat-icon>
  <div class="file-name">
    {{ getFormattedFilename(file.file_name) }}
    <mat-icon
      class="delete-button"
      *ngIf="showDeleteButton"
      (click)="onDeleteClick()"
      >clear</mat-icon
    >
  </div>
</div>